module.exports = __webpack_public_path__ + "static/media/aufraeumen-mit-system.dabd0c87.png";